import * as _ from 'lodash';
import Migration from './migration';

import Objects from './001-objects';

const migrations: Array<Migration> = _.sortBy([new Objects()], (m) => m.number);

export default migrations;
